var map = {
	"./object-1/petshealth-1.png": 70,
	"./object-1/petshealth-2.png": 71,
	"./object-1/petshealth-3.png": 72,
	"./object-1/petshealth-4.png": 73,
	"./object-1/petshealth-5.png": 74,
	"./object-1/slide-1.png": 75,
	"./object-1/slide-2.png": 76,
	"./object-1/slide-3.png": 77,
	"./object-1/slide-4.png": 78,
	"./object-1/slide-5.png": 79,
	"./object-1/slide-6.png": 80,
	"./object-2/ap-1.png": 81,
	"./object-2/ap-2.png": 82,
	"./object-2/ap-3.png": 83,
	"./object-2/ap-4.png": 84,
	"./object-2/slide-1.png": 85,
	"./object-2/slide-2.png": 86,
	"./object-2/slide-3.png": 87,
	"./object-2/slide-4.png": 88,
	"./object-2/slide-5.png": 89,
	"./object-3/slide-1.png": 90,
	"./object-3/slide-2.png": 91,
	"./object-3/slide-3.png": 92,
	"./object-3/slide-4.png": 93,
	"./object-3/slide-5.png": 94,
	"./object-3/vestum1.png": 95,
	"./object-3/vestum2.png": 96,
	"./object-3/vestum3.png": 97,
	"./object-3/vestum4.png": 98,
	"./object-3/vestum5.png": 99,
	"./object-4/kuh-1.png": 100,
	"./object-4/kuh-2.png": 101,
	"./object-4/kuh-3.png": 102,
	"./object-4/kuh-4.png": 103,
	"./object-4/kuh-5.png": 104,
	"./object-4/slide-1.png": 105,
	"./object-4/slide-2.png": 106,
	"./object-4/slide-3.png": 107,
	"./object-4/slide-4.png": 108,
	"./object-4/slide-5.png": 109,
	"./object-5/perecup1.png": 110,
	"./object-5/perecup2.png": 111,
	"./object-5/perecup3.png": 112,
	"./object-5/perecup4.png": 113,
	"./object-5/perecup5.png": 114,
	"./object-5/slide-1.png": 115,
	"./object-5/slide-2.png": 116,
	"./object-5/slide-3.png": 117,
	"./object-5/slide-4.png": 118,
	"./object-5/slide-5.png": 119
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69;